/* hs-eslint ignored failing-rules */
/* eslint-disable @typescript-eslint/no-floating-promises */

import { dataFetchingClient } from '../../utils/DataFetchingClient';
import { queryDataFromCache, updateCache } from '../../utils/DataFetchingClientCache.new';
import { GET_PLAYLIST_OR_LEARNING_PATH_QUERY, updatePlaylistFromCache, useUpdatePlaylist } from '../savedItems/savedItemsQueries.migrated';
import { useCallback } from 'react';
import { useSearchQuery, useSavePlaylistMutation, useUnsavePlaylistMutation } from '../../../__generated__/chirp/com/hubspot/learning/center/playlists/rpc/PlaylistChirpService.hooks';
import { SEARCH_QUERY_FIELD_NAME } from '../../../__generated__/chirp/com/hubspot/learning/center/playlists/rpc/PlaylistChirpService.dfc.new';
const addPlaylistsToCache = playlists => {
  playlists.forEach(playlist => {
    const variables = {
      playlistId: playlist.id
    };
    if (!queryDataFromCache(GET_PLAYLIST_OR_LEARNING_PATH_QUERY, variables)) {
      updateCache(GET_PLAYLIST_OR_LEARNING_PATH_QUERY, () => playlist, variables);
    }
  });
};
const PAGE_SIZE = 12;
export const useMyPlaylists = ({
  interactionTypes = ['CREATED', 'ASSIGNED', 'SAVED'],
  limit,
  page,
  query,
  sortProperty,
  sortOrder,
  skip = false
} = {
  interactionTypes: ['CREATED', 'ASSIGNED', 'SAVED']
}) => {
  const {
    data: playlistsResponse,
    loading: playlistsLoading,
    error: playlistsError
  } = useSearchQuery({
    skip,
    variables: {
      interactionTypes,
      query,
      limit: limit || PAGE_SIZE,
      types: ['STANDARD', 'LEARNING_PATH'],
      sortProperty: sortProperty || 'interactedAt',
      sortOrder: sortOrder || 'DESC',
      pageLength: limit || PAGE_SIZE,
      offset: {
        cursor: limit && page ? limit * (page - 1) : 0
      }
    }
  });
  if (playlistsResponse && playlistsResponse.results) {
    addPlaylistsToCache(playlistsResponse.results);
  }
  return {
    totalPlaylists: playlistsResponse ? playlistsResponse.totalCount : 0,
    offset: playlistsResponse ? playlistsResponse.offset.cursor : 0,
    hasMore: playlistsResponse ? playlistsResponse.hasMore : false,
    playlists: playlistsResponse ? playlistsResponse.results : null,
    playlistsLoading,
    playlistsError
  };
};
export const refetchMyPlaylists = () => {
  dataFetchingClient.refetchQueries({
    updateCache(cache) {
      cache.evict({
        fieldName: SEARCH_QUERY_FIELD_NAME
      });
    }
  });
};
export const useSetHiddenForOwner = (playlistId, hiddenForOwner) => {
  const onCompleted = () => {
    refetchMyPlaylists();
  };
  const [mutate, {
    updatePlaylistMutationLoading: archievePlaylistMutationLoading,
    updatePlaylistMutationCalled: archievePlaylistMutationCalled,
    updatePlaylistMutationError: archievePlaylistMutationError
  }] = useUpdatePlaylist(playlistId, {
    onCompleted
  });
  const setHiddenForOwner = useCallback(() => {
    return mutate({
      hiddenForOwner
    });
  }, [hiddenForOwner, mutate]);
  return [setHiddenForOwner, {
    archievePlaylistMutationLoading,
    archievePlaylistMutationCalled,
    archievePlaylistMutationError
  }];
};
export const useSavePlaylist = playlistId => {
  const [mutate, {
    loading: savePlaylistMutationLoading,
    called: savePlaylistMutationCalled,
    error: savePlaylistMutationError
  }] = useSavePlaylistMutation({
    variables: {
      playlistId
    },
    update: () => {
      refetchMyPlaylists();
      updatePlaylistFromCache(playlistId, {
        savedByUser: true
      });
    }
  });
  return [mutate, {
    savePlaylistMutationLoading,
    savePlaylistMutationCalled,
    savePlaylistMutationError
  }];
};
export const useUnsavePlaylist = playlistId => {
  const [mutate, {
    loading: unsavePlaylistMutationLoading,
    called: unsavePlaylistMutationCalled,
    error: unsavePlaylistMutationError
  }] = useUnsavePlaylistMutation({
    variables: {
      playlistId
    },
    update: () => {
      refetchMyPlaylists();
      updatePlaylistFromCache(playlistId, {
        savedByUser: false
      });
    }
  });
  return [mutate, {
    unsavePlaylistMutationLoading,
    unsavePlaylistMutationCalled,
    unsavePlaylistMutationError
  }];
};